import { BaseModel } from './BaseModel';
import { Ration } from './Ration';


export class Phase extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.startAge = isApi ? data.start_age : data.startAge;

    this.endAge = isApi ? data.end_age : data.endAge;

    this.ration = Ration.create(data.ration, source);
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class NutritionalPlan extends BaseModel {
  hydrate(data, source) {
    this.name = data.name;

    this.phases = data.phases ? data.phases.map((p) => Phase.create(p, source)) : []
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}